export const HEADER_HEIGHT = 50;
export const SIDEBAR_WIDTH = 300;
export const COLLAPSED_SIDEBAR_WIDTH = 80;
export const COLLAPSED_MENU_BG_COLOR = '#fcfcfd';
export const EXPERIMENT_CARD_HEIGHT = '220';
export const EXPERIMENT_CARD_WIDTH = '330';
